<template>
  <v-app>
    <div class="mapa-container">
      <div class="header-controls">
        <!-- Dropdown Esquerdo: Pesquisar -->
        <div class="dropdown left">
          <div class="map-logo">
            <img src="@/assets/images/logo.png" alt="eSUS Feedback" />
          </div>
          <v-menu
            v-model="enabledHeaderControlLeft"
            offset-y
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" class="dropdown-button">
                Pesquisar
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <v-card class="dropdown-content">
              <div class="filters-wrapper">
                <vue-select
                  v-model="region"
                  :options="regions"
                  label="label"
                  placeholder="REGIÃO"
                  @input="onChangeRegions"
                  class="grafico-select"
                  :disabled="disabelRegions"
                >
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
                <vue-select
                  v-model="state"
                  :options="states"
                  label="uf"
                  placeholder="UF"
                  @input="onChangeStates"
                  class="grafico-select"
                  :disabled="disableStates"
                >
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
                <vue-select
                  v-model="macroRegion"
                  multiple
                  :options="macroRegions"
                  label="MACRO REGIÃO"
                  placeholder="MACRO REGIÃO"
                  @input="onChangeMacroRegion"
                  class="grafico-select"
                  :disabled="disableMacroRegion"
                  :loading="loading"
                >
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
                <vue-select
                  v-model="regionalValue"
                  multiple
                  :options="regional"
                  label="REGIONAL"
                  placeholder="REGIONAL"
                  @input="onChangeRegional"
                  class="grafico-select"
                  :disabled="disableRegional"
                  :loading="loading"
                >
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
                <vue-select
                  v-model="city"
                  :options="optionsCities"
                  label="Município"
                  placeholder="MUNICÍPIO"
                  @input="onChangeCities"
                  class="grafico-select"
                  :disabled="disableCities"
                  :loading="loading"
                >
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
              <div class="d-flex align-items-end justify-content-end pb-2 pr-2">
                <v-btn
                  v-on="on"
                  @click="enabledHeaderControlLeft = false"
                  class="hide-button"
                >
                  Ocultar
                </v-btn>
              </div>
            </v-card>
          </v-menu>
        </div>
        <!-- Dropdown Direito: Ações -->
        <div class="dropdown right">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" class="dropdown-button">
                Ações
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click.stop.prevent="
                  city !== null && atualizarLocalizacaoDasUbsDoMunicipio()
                "
                :disabled="city == null"
                style="cursor: pointer"
              >
                <v-list-item-icon>
                  <v-icon :class="{ 'v-icon--disabled': city == null }">
                    mdi-map
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>
                    <template v-if="loadingLocalizacaoUbs">
                      <div style="display: flex; align-items: center; gap: 8px">
                        <v-progress-circular
                          indeterminate
                          size="16"
                          width="2"
                          color="primary"
                        />
                        Atualizando
                      </div>
                    </template>
                    <template v-else> Localização </template>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="showModalAjuda()">
                <v-list-item-icon
                  ><v-icon>mdi-help-circle-outline</v-icon></v-list-item-icon
                >
                <v-list-item-content>Ajuda</v-list-item-content>
              </v-list-item>
              <v-list-item @click="showModalTabela()">
                <v-list-item-icon><v-icon>mdi-table</v-icon></v-list-item-icon>
                <v-list-item-content>Informações</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>

      <div class="map-wrapper">
        <l-map
          :zoom.sync="zoom"
          :center="center"
          style="width: 100%"
          ref="map"
          :options="{ zoomControl: false }"
        >
          <l-tile-layer :url="url" :attribution="attribution" />
          <l-control-zoom position="bottomright"></l-control-zoom>
        </l-map>
      </div>
    </div>

    <ModalAjuda :modalData="modalAjuda" />

    <ModalInformacoes :modalData="modalTabela" :tableData="tableData" />
  </v-app>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import {
  LMap,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { coordinatesStates, coordinatesRegions } from '../utils/coordinates.js'
import { statesBR } from '../utils/states.js'
import { sisab, tableData } from './utils/sisab.js'
import { infoHtml } from './utils/ajuda.js'
import utils from '@/mixins/utils.js'
import 'leaflet.markercluster/dist/leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import ModalAjuda from './components/ModalAjuda.vue'
import ModalInformacoes from './components/ModalInformacoes.vue'

export default {
  name: 'MapaUbs',
  components: {
    PulseLoader,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    'vue-select': VueSelect,
    LMarkerCluster: L.markerClusterGroup,
    ModalAjuda,
    ModalInformacoes,
  },
  mixins: [utils],
  data() {
    return {
      tableData: tableData,
      comEsus: false,
      steps: '',
      zoom: 5,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      icon: icon({
        iconUrl: require('@/assets/icones/iconemapa2.png'),
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      staticAnchor: [16, 37],
      customText: 'Foobar',
      iconSize: 64,

      regions: [
        {
          value: 'sul',
          label: 'Sul',
        },
        {
          value: 'sudeste',
          label: 'Sudeste',
        },
        {
          value: 'norte',
          label: 'Norte',
        },
        {
          value: 'nordeste',
          label: 'Nordeste',
        },
        {
          value: 'centro-oeste',
          label: 'Centro-Oeste',
        },
      ],
      disableIndicador: true,
      ieds: [
        {
          label: 'IED = 1',
          color: 'red',
        },
        {
          label: 'IED = 2',
          color: 'orange',
        },
        {
          label: 'IED = 3',
          color: 'yellow',
        },
        {
          label: 'IED = 4',
          color: 'green',
        },
      ],
      region: [],
      population: [],
      populations: [
        {
          value: 'de 50.001 a 100.000',
          label: 'de 50.001 a 100.000',
        },
        {
          value: 'de 5.001 a 10.000',
          label: 'de 5.001 a 10.000',
        },
        {
          value: 'de 20.001 a 50.000',
          label: 'de 20.001 a 50.000',
        },
        {
          value: 'de 100.001 a 500.000',
          label: 'de 100.001 a 500.000',
        },
        {
          value: 'de 10.001 a 20.000',
          label: 'de 10.001 a 20.000',
        },
        {
          value: 'até 5.000',
          label: 'até 5.000',
        },
        {
          value: 'acima de 500.000 hab.',
          label: 'acima de 500.000 hab.',
        },
      ],

      state: '',
      states: [],
      city: null,
      optionsCities: [],
      optionsCitiesOrigins: [],
      disableCities: true,
      /*     states: [...statesBR], */
      macroRegion: [],
      macroRegions: [],
      regional: [],
      regionalValue: '',
      isf: [],
      markersFilter: [],
      dataToFilter: [],
      disabelRegions: false,
      disableStates: true,
      disablePopulation: false,
      disableMacroRegion: true,
      disableRegional: true,
      disableIsf: true,
      dataFilterCitiesRegion: [],
      dataFilterCity: null,
      dataFilterPopulation: [],
      dataFilterMacroRegions: [],
      dataFilterRegional: [],
      dataFilterIsf: [],
      info: {
        type: 'municipio',
        title:
          'Os primeiros da lista são municípios com melhor desempenho, ou seja, ISF mais alto.',
      },
      dados: [],
      dadosOriginaisDaRequisicao: [],
      nomeMunicipio: '',
      loading: false,
      loadingPdf: false,
      nome: '',
      quadrimestre: '',
      quadrimestres: [],
      temEstadoSelecionado: false,
      size: '40px',
      color: '#0D98BB',
      modalAjuda: {
        enabled: true,
        text: infoHtml,
      },
      modalTabela: {
        enabled: false,
      },
      openedModalSeloAps: false,
      openedModalPorcentagem: false,
      seloApsImg: '',
      porcentagemImg: '',
      loading: false,
      ubsDoMunicipio: [],
      loadingLocalizacaoUbs: false,
      layerLimiteMunicipal: null,
      markerCluster: null,
      enabledHeaderControlLeft: false,
    }
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15]
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15]
    },
  },
  async mounted() {
    this.initMap()
  },
  methods: {
    initMap() {
      const mapObject = this.$refs.map.mapObject
      // Inicializando a camada de desenho
      this.layerLimiteMunicipal = new L.FeatureGroup()
      // Adiciona os layers
      mapObject.addLayer(this.layerLimiteMunicipal)
      this.markerCluster = L.markerClusterGroup()
    },

    showModalAjuda() {
      this.modalAjuda.enabled = true
    },

    showModalTabela() {
      this.modalTabela.enabled = true
    },

    getCoordinates(isRegion = false) {
      setTimeout(() => {
        let selectedCoordinates
        if (isRegion) {
          // pega as coordenadas da região
          const regionCoordinates = coordinatesRegions.find((item) => {
            return item.region === this.region.label
          })
          selectedCoordinates = regionCoordinates
        } else {
          // pega as coordenadas do estado
          const stateCoordinates = coordinatesStates.find((item) => {
            return item.uf === this.state
          })
          selectedCoordinates = stateCoordinates
        }

        const mapObject = this.$refs.map.mapObject
        mapObject.setView(
          latLng(selectedCoordinates.lat, selectedCoordinates.lgn),
          selectedCoordinates.zoom
        )
      }, 500)
    },

    filter(
      dataFilterCitiesRegion,
      dataFilterCity,
      dataFilterPopulation,
      dataFilterMacroRegions,
      dataFilterRegional
    ) {
      let data = []
      data = this.dadosOriginaisDaRequisicao
      // Busca todas cidades da região
      if (dataFilterCitiesRegion.length > 0) {
        data = this.allCitiesInRegion(dataFilterCitiesRegion)
      }
      // busca todas as cidades do estado

      if (this.state !== '') {
        data = this.allCitiesByState(this.state)
      }

      // Filtra por cidade
      if (dataFilterCity !== null) {
        data = this.cityFilter(data)
      }
      // filtra por população
      if (dataFilterPopulation.length > 0) {
        data = this.citiesByPopulation(dataFilterPopulation)
      }

      // filtra por macro região
      if (dataFilterMacroRegions.length > 0) {
        data = this.citiesByMacroRegions(
          data,
          this.state,
          dataFilterMacroRegions
        )
      }

      // filtra por regional
      if (dataFilterRegional.length > 0) {
        data = this.citiesByRegional(data, this.state, dataFilterRegional)
      }

      // Tira os dados sem localização
      data = data.filter((item) => {
        return (
          item?.latitude != '0' &&
          item?.latitude != null &&
          item?.latitude != undefined &&
          item?.latitude != '' &&
          item?.longitude != '0' &&
          item?.longitude != null &&
          item?.longitude != undefined &&
          item?.longitude != ''
        )
      })

      this.dados = data

      this.addMarkers()
    },

    async onChangeRegions(event) {
      // Resetar Indicador
      /*  this.setIndicadorInitial() */
      this.dados = []
      this.dadosOriginaisDaRequisicao = []
      this.disableIndicador = true
      this.comEsus = false
      this.city = null
      if (event !== null) {
        this.steps = 'regiao'
        this.disableStates = false
        this.state = ''
        this.states = []
        this.macroRegions = []
        this.macroRegion = []
        this.regional = []
        this.regionalValue = ''
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []
        this.region = event

        const dataUf = []
        dataUf.push(event.value)

        const data = statesBR.filter((item) => {
          return dataUf.includes(item.region)
        })

        this.states = data

        this.dataFilterCitiesRegion = data.map((element) => {
          return element.uf
        })
      } else {
        this.steps = ''
        this.state = ''
        this.states = []
        this.macroRegions = []
        this.macroRegion = []
        this.regional = []
        this.regionalValue = ''
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        this.dados = []
        this.dadosOriginaisDaRequisicao = []
        // Disabled
        this.disableStates = true
        this.disableCities = true
        this.disableMacroRegion = true
        this.disableRegional = true
      }
    },

    async onChangeStates(event) {
      this.steps = 'estado'
      this.dataFilterRegional = []
      this.regionalValue = ''
      this.disableRegional = true
      this.comEsus = false
      this.city = null
      this.dataFilterCity = null
      if (event !== null) {
        this.dataFilterMacroRegions = []
        this.dataFilterRegional = []
        this.macroRegion = []
        this.macroRegions = []
        this.population = []
        this.state = event.uf
        this.regional = []
        this.disableMacroRegion = false
        this.disableIndicador = false

        // Busca todos os dados
        await this.allCities()

        // Separa os municipios
        this.getCity()
        this.disableCities = false

        // pega as coordenadas do estado
        this.getCoordinates()
        // busca as macro regiões do estado
        this.allMacroRegionByState(this.state)
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = 'regiao'
        this.state = ''
        this.city = null
        this.regional = []
        this.population = []
        this.macroRegions = []
        this.macroRegion = []
        this.regionalValue = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []
        this.dados = []
        this.dadosOriginaisDaRequisicao = []
        // Resetar Indicador
        /*   this.setIndicadorInitial() */

        // Disabled
        this.disableCities = true
        this.disableMacroRegion = true
        this.disableIndicador = true
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },
    // Popula o select de cidade
    getCity() {
      const municipios = new Set()
      if (this.macroRegion.length === 0 && this.regionalValue.length === 0) {
        this.dadosOriginaisDaRequisicao.forEach((item) => {
          if (item.no_uf === this.state) {
            municipios.add(item.no_municipio)
          }
        })
      }
      if (this.macroRegion.length !== 0) {
        this.dadosOriginaisDaRequisicao.forEach((item) => {
          if (this.regionalValue.length !== 0) {
            if (
              item.no_uf === this.state &&
              this.macroRegion.includes(item.no_macro_regiao) &&
              this.regionalValue.includes(item.no_regiao_saude)
            ) {
              municipios.add(item.no_municipio)
            }
          } else {
            if (
              item.no_uf === this.state &&
              this.macroRegion.includes(item.no_macro_regiao)
            ) {
              municipios.add(item.no_municipio)
            }
          }
        })
      }

      this.optionsCities = Array.from(municipios)
    },

    async onChangeCities(event) {
      this.allMacroRegionByState(this.state)
      this.allRegionalByState(this.state, this.macroRegion)
      if (event !== null) {
        this.dataFilterCity = event
        this.disableRegional = false
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
        /*    if (this.macroRegions.length === 1) { */
        this.macroRegion = this.macroRegions
        this.disableMacroRegion = false
        this.allRegionalByState(this.state, this.macroRegions)
        /* } */
        /* if (this.regional.length === 1) { */
        this.regionalValue = this.regional
        this.disableRegional = false
        /* } */
        this.dataFilterMacroRegions = this.macroRegion
        this.dataFilterRegional = this.regionalValue
        this.getCity()
        let municipio = this.dadosOriginaisDaRequisicao.find(
          (el) => el.no_municipio == event
        )

        // Exibe o limite municipal
        try {
          const response = await this.$apiPublic.get(
            '/cofinanciamento-2024/mapa/ubs/' +
              municipio.ibge_completo +
              '/limite-municipal'
          )
          if (response.data) {
            this.layerLimiteMunicipal.clearLayers()
            const geoData = JSON.parse(response.data.limite_municipal)
            if (geoData) {
              if (geoData.type == 'MultiPolygon') {
                geoData.coordinates.forEach((polygon) => {
                  const polygonLatLngs = polygon.map((ring) =>
                    ring.map((coord) => [coord[1], coord[0]])
                  )
                  const polygonLayer = L.polygon(polygonLatLngs, {
                    fillColor: 'transparent',
                  })
                  this.layerLimiteMunicipal.addLayer(polygonLayer)
                })
              } else {
                const polygonLatLngs = geoData.coordinates[0].map((coord) => [
                  coord[1],
                  coord[0],
                ])
                const polygonLayer = L.polygon(polygonLatLngs, {
                  fillColor: 'transparent',
                })
                this.layerLimiteMunicipal.addLayer(polygonLayer)
              }
            }
          }
        } catch (error) {
          console.log(error)
        }
        this.getUbsDoMunicipio(municipio.ibge)
      } else {
        this.layerLimiteMunicipal.clearLayers()
        this.dataFilterCity = null
        this.disableMacroRegion = false
        this.disableRegional = false

        /*  this.macroRegion = []
        this.regional = [] */
        /*     this.regionalValue = '' */

        this.dataFilterMacroRegions = this.macroRegion
        this.dataFilterRegional = this.regionalValue

        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },
    onChangeMacroRegion(event) {
      this.city = null
      this.steps = 'macroRegiao'
      this.dataFilterRegional = []
      this.regionalValue = ''
      this.comEsus = false
      if (event.length > 0) {
        const dataFilterMacroRegions = []
        event.forEach((element) => {
          dataFilterMacroRegions.push(element)
        })
        dataFilterMacroRegions.push(event)
        this.dataFilterMacroRegions = dataFilterMacroRegions

        // busca as regiões do estado
        this.allRegionalByState(this.state, this.dataFilterMacroRegions)
        this.disableMacroRegion = false
        this.disableRegional = false
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
        this.getCity()
      } else {
        this.steps = 'estado'
        this.macroRegion = []
        this.disableRegional = true
        this.dataFilterMacroRegions = []
        this.regionalValue = ''
        this.dataFilterRegional = []
        this.dataFilterCity = null
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
        this.getCity()
      }
    },

    onChangeRegional(event) {
      this.city = null
      this.comEsus = false
      this.dataFilterCity = null
      if (event.length > 0) {
        this.steps = 'regional'
        const dataFilterRegional = []
        event.forEach((element) => {
          dataFilterRegional.push(element)
        })
        this.dataFilterRegional = dataFilterRegional
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
        this.getCity()
      } else {
        this.regionalValue = ''
        this.dataFilterRegional = []
        this.dataFilterMacroRegions = this.macroRegion
        this.dataFilterCity = null
        this.getCity()
        this.allMacroRegionByState(this.state)
        this.allRegionalByState(this.state, this.macroRegion)

        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },
    async allCities() {
      try {
        this.loading = true
        let url = `/cofinanciamento-2024/mapa/ubs/${this.state}`
        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data.filter((item) => {
            const hasCadSisab =
              item.cad_sisab !== undefined &&
              item.cad_sisab !== null &&
              item.cad_sisab !== '' &&
              item.cad_sisab !== '-'
            const hasFaixaPopulacional =
              item.faixa_populacional !== undefined &&
              item.faixa_populacional !== null &&
              item.faixa_populacional !== '' &&
              item.faixa_populacional !== '-'
            const hasTipoEquipe =
              item.tipo_equipe !== undefined &&
              item.tipo_equipe !== null &&
              item.tipo_equipe !== '' &&
              item.tipo_equipe !== '-'
            return hasCadSisab && hasFaixaPopulacional && hasTipoEquipe
          })
          this.dadosOriginaisDaRequisicao = this.dados
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // Buscas todos registros de todas cidades da região
    allCitiesInRegion(cities) {
      const allData = this.dadosOriginaisDaRequisicao

      const data = allData.filter((item) => {
        return cities.includes(item.no_uf)
      })
      return data
    },

    // Busca todas cidades por estado
    allCitiesByState(uf) {
      const allData = this.dadosOriginaisDaRequisicao
      const data = allData.filter((item) => {
        return item.no_uf === uf
      })
      return data
    },
    // Busca dados da cidade
    cityFilter(data) {
      const res = data.filter((item) => {
        return item.no_municipio === this.dataFilterCity
      })
      return res
    },
    // Busca todas cidades por macro região
    citiesByMacroRegions(data, uf, macroRegions) {
      const res = data.filter((item) => {
        return item.no_uf === uf && macroRegions.includes(item.no_macro_regiao)
      })
      return res
    },
    // Busca todas cidades por regional
    citiesByRegional(data, uf, regional) {
      const res = data.filter((item) => {
        return item.no_uf === uf && regional.includes(item.no_regiao_saude)
      })
      return res
    },

    citiesByPopulation(population) {
      const allData = this.allCities()
      const data = allData.filter((item) => {
        return population.includes(item.faixa_populacional)
      })
      // Passa a data e o limite de municipios
      return data
      /*  return this.ordenando(data, 100) */
    },

    // Popula o select macroRegions
    allMacroRegionByState(uf) {
      const allData = this.dadosOriginaisDaRequisicao
      const states = allData.filter((item) => {
        if (this.city === null) {
          return item.no_uf === uf
        }
        return item.no_uf === uf && item.no_municipio === this.city
      })
      const data = []
      states.forEach((element) => {
        data.push(element.no_macro_regiao)
      })
      // removendo valores duplicados
      const result = data
        .map((e) => JSON.stringify(e))
        .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
        .map((e) => JSON.parse(e))
      this.macroRegions = result
    },
    // Popula o select regional allRegionalByState
    allRegionalByState(uf, macroRegiao) {
      const allData = this.dadosOriginaisDaRequisicao
      const states = allData.filter((item) => {
        if (this.city === null) {
          return item.no_uf === uf && macroRegiao.includes(item.no_macro_regiao)
        }
        return (
          item.no_uf === uf &&
          macroRegiao.includes(item.no_macro_regiao) &&
          item.no_municipio === this.city
        )
      })
      const data = []
      states.forEach((element) => {
        data.push(element.no_regiao_saude)
      })

      // removendo valores duplicados
      const result = data
        .map((e) => JSON.stringify(e))
        .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
        .map((e) => JSON.parse(e))

      this.regional = result.filter((item) => item !== null)
    },

    getRadius(cad_sisab) {
      let population = cad_sisab
      const minRadius = 10
      const maxRadius = 100
      const minPopulation = 0
      const maxPopulation = 10000

      // Ensure that the population is within bounds
      if (population < minPopulation) population = minPopulation
      if (population > maxPopulation) population = maxPopulation

      // Calculate the radius using linear interpolation
      let radius =
        minRadius +
        ((population - minPopulation) / (maxPopulation - minPopulation)) *
          (maxRadius - minRadius)

      return radius
    },
    getColor(api) {
      const faixaPopulacional = parseInt(api.faixa_populacional.split('-')[0])
      const tipoEquipe = api.tipo_equipe
      const cadSisab = parseInt(api.cad_sisab)
      const indiceFaixa = faixaPopulacional - 1

      if (
        tipoEquipe !== 'eSF' &&
        tipoEquipe !== 'eAP-30h' &&
        tipoEquipe !== 'eAP-20h'
      ) {
        return 'orange'
      }

      const min = sisab[indiceFaixa][tipoEquipe].min
      const max = sisab[indiceFaixa][tipoEquipe].max

      if (cadSisab > max) {
        return 'red'
      } else if (cadSisab < min) {
        return 'yellow'
      } else if (cadSisab > min && cadSisab < max) {
        return 'green'
      }
      return 'blue'
    },

    async getUbsDoMunicipio(ibge) {
      try {
        const response = await this.$apiPublic.get(
          '/cofinanciamento-2024/ubs/' + ibge
        )
        if (response) {
          this.ubsDoMunicipio = []
          this.ubsDoMunicipio = response.data
        }
      } catch (error) {
        console.log(error)
      }
    },

    async atualizarLocalizacaoDasUbsDoMunicipio() {
      try {
        // Obter a data atual
        let dataAtual = new Date()
        // Obter o dia do mês
        let diaAtual = dataAtual.getDate()
        // Verificar se o dia está entre 7 e 18
        // if (diaAtual >= 7 && diaAtual <= 18) {
        //   this.$toast.warning(
        //     'Competência para o envio do CNES, provavelmente, está fechada. Por favor, tentar atualizar com a competência de envio do CNES aberta.',
        //     'Atenção:',
        //     {
        //       position: 'topRight',
        //     }
        //   )
        //   return
        // }

        if (this.ubsDoMunicipio.length > 0) {
          let ultimaAtualizacao =
            this.ubsDoMunicipio[0].updated_at.split(' ')[0]
          const diferencaDias = this.diffDays(ultimaAtualizacao)
          if (diferencaDias < 3) {
            this.$toast.warning(
              'Localização atualizada recentemente, por favor, tentar novamente em 3 dias.',
              'Atenção:',
              {
                position: 'topRight',
              }
            )
            return
          }

          this.loadingLocalizacaoUbs = true

          for (let index = 0; index < this.ubsDoMunicipio.length; index++) {
            const element = this.ubsDoMunicipio[index]
            try {
              const response = await this.$apiPublic.put(
                '/cofinanciamento-2024/ubs/localizacao',
                {
                  cnes: element.cnes,
                }
              )
              if (response.data.error == true) {
                console.log('Erro ao atualizar localização')
              }
            } catch (innerError) {
              console.log(
                `Erro ao atualizar localização para o CNES: ${element.cnes}`,
                innerError
              )
            }
          }
          this.loadingLocalizacaoUbs = false
        }
      } catch (error) {
        console.log(error)
        this.loadingLocalizacaoUbs = false
      }
    },

    addMarkers() {
      if (this.markerCluster) {
        this.markerCluster.clearLayers()
      }
      const mapObject = this.$refs.map.mapObject
      const markersData = this.dados

      markersData.forEach((data) => {
        if (data.latitude && data.longitude) {
          // const marker = L.marker([data.latitude, data.longitude])
          const marker = L.circleMarker([data.latitude, data.longitude], {
            radius: this.getRadius(data?.cad_sisab),
            color: this.getColor(data?.cad_sisab !== '' && data ? data : ''),
            fillColor: this.getColor(
              data?.cad_sisab !== '' && data ? data : ''
            ),
            stroke: false,
            fillOpacity: 0.6,
          })

          const popupContent = `
            <div class="tooltip-latlgn">
              <strong
            >${data?.no_municipio} - ${data?.no_uf}</strong
          >
          <br />
          <span> PORTE: ${data.faixa_populacional} </span>
          <br />
          <span> UBS: ${data?.no_ubs}</span>
          <br />
          <span>
            CNES + INE: ${data?.cnes} | ${data?.ine} |
            ${data?.tipo_equipe}</span
          >
          <br />
          <span> CADASTROS MÍNIMO: ${data?.min_cad} </span>
          <br />
          <span> CADASTROS SISAB: ${data?.cad_sisab} </span>
          <br />
          <span> CADASTROS MÁXIMO: ${data?.max_cad} </span>
            </div>
          `

          // Adicionar tooltip permanente com as opções fornecidas
          marker
            .bindTooltip(data.denominador, {
              permanent: true,
              direction: 'center',
              className: 'map-radius',
              interactive: true,
            })
            .openTooltip()

          // Adicionar evento de mouseover para mostrar o popup
          marker.on('mouseover', function () {
            marker.bindPopup(popupContent).openPopup()
          })

          // Adicionar evento de mouseout para fechar o popup
          marker.on('mouseout', function () {
            marker.closePopup()
          })

          this.markerCluster.addLayer(marker)
        }
      })

      mapObject.addLayer(this.markerCluster)
    },
  },
}
</script>

<style scoped lang="scss" src="./styles.scss" />
